import * as React from 'react';

import { getTermsValue, NonEmptyArray } from '../../../../../JsonQuery';
import { FlatRooms } from '../../../components/advancedFilters/FlatRooms';
import { ERoomsTotal } from '../../../types/jsonQuery';
import { useContext } from '../../../utils/useContext';

export const FlatRoomsContainer: React.FC = () => {
  const { jsonQuery, onChange } = useContext();
  let rooms = getTermsValue('rooms_count')(jsonQuery);
  if (rooms && rooms.length === 0) {
    rooms = null;
  }

  const handleChange = React.useCallback(
    (value: NonEmptyArray<ERoomsTotal> | null) => {
      onChange({ action: 'setRoomsCount', arguments: [value] });
    },
    [onChange],
  );

  return <FlatRooms value={rooms as NonEmptyArray<ERoomsTotal> | null} onChange={handleChange} />;
};
